import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import * as API from "../../Utils/Services/api";
import {
  Button,
  Container,
  Form,
  ListGroup,
  Modal,
  Pagination,
} from "react-bootstrap";
import EditAdminCoinModal from "./EditAdminCoinModal";
import { toast } from "react-toastify";

const AdminCoinDetail = () => {
  const navigate = useNavigate();
  // const { id } = useParams();
  // const [coin, setCoin] = useState(null);
  // const [editModal, setEditModal] = useState(false);
  // const [editedCoin, setEditedCoin] = useState({});
  const { id } = useParams();
  const [reviews, setReviews] = useState([]);
  const [coin, setCoin] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const perPage = 10;

  // useEffect(() => {
  //   const storedCoin = JSON.parse(localStorage.getItem("selectedCoin"));
  //   if (storedCoin?.id === id) {
  //     setCoin(storedCoin);
  //   }
  // }, [id]);

  // const handleEditClick = () => {
  //   setEditedCoin({ ...coin });
  //   setEditModal(true);
  // };

  useEffect(() => {
    const fetchData = async () => {
      const res = await API.GetAllReviewsAdmin();
      const matched = res.data.review.find(
        (r) => r.tokenId?.toLowerCase() === id.toLowerCase()
      );
      if (matched) {
        setCoin(matched.tokenId);
        setReviews(matched.review || []);
      }
    };
    fetchData();
  }, [id]);

  const paginated = reviews.slice(
    (currentPage - 1) * perPage,
    currentPage * perPage
  );
  const totalPages = Math.ceil(reviews.length / perPage);

  return (
    // <div className="condo-admin-dashboard-pg condo-admin-coin-details">
    //   <div className="container">
    //     <div className="google-analytics-condo">
    //       <div className="row">
    //         <div className="coin-details-page-admin">
    //           <h2>{coin.name} Details</h2>
    //           <img
    //             src={coin.customImage}
    //             alt={coin.name}
    //             style={{ width: 80 }}
    //           />
    //           <p>
    //             <strong>Description:</strong> {coin.customDescription}
    //           </p>{" "}
    //           <p>
    //             <strong>Market Cap:</strong> ${coin.marketCap.toLocaleString()}
    //           </p>
    //           <Button variant="primary" onClick={handleEditClick}>
    //             Edit
    //           </Button>{" "}
    //           <br />
    //           <p>
    //             <strong>Symbol:</strong> {coin.symbol.toUpperCase()}
    //           </p>
    //           <p>
    //             <strong>Price:</strong> ${coin.current_price}
    //           </p>
    //           <p>
    //             <strong> Ratings:</strong>{" "}
    //             {coin.reviews.length ? (
    //               // ? (
    //               //     coin.reviews.reduce(
    //               //       (sum, r) => sum + (r.rating || 0),
    //               //       0
    //               //     ) / coin.reviews.length
    //               //   ).toFixed(1) && (
    //               <ul>
    //                 {coin.reviews.map(
    //                   (r, i) => (
    //                     // r.rating > 0 && (
    //                     <li key={i}>
    //                       <>
    //                         <strong>{r.author}</strong>: ({r.rating}{" "}
    //                         <i class="fa-solid fa-star fa-xs"></i>)
    //                       </>
    //                     </li>
    //                   )
    //                   // )
    //                 )}
    //               </ul>
    //             ) : (
    //               "No rating yet"
    //             )}{" "}
    //           </p>
    //           <h4>Expert Reviews</h4>
    //           {coin.reviews.length ? (
    //             <ol>
    //               {coin.reviews.map((r, i) => (
    //                 <li key={i}>
    //                   <strong>{r.author}</strong>: {r.review}
    //                 </li>
    //               ))}
    //             </ol>
    //           ) : (
    //             <p>No reviews yet.</p>
    //           )}
    //         </div>
    //       </div>
    //     </div>
    //   </div>{" "}
    //   {/* Modal */}
    //   <EditAdminCoinModal
    //     show={editModal}
    //     onHide={() => setEditModal(false)}
    //     coin={coin}
    //     onSave={(updated) => {
    //       // setCoin(updated);
    //       setCoin((prevCoins) =>
    //         prevCoins.map((c) => (c._id === updated._id ? updated : c))
    //       );

    //       localStorage.setItem("selectedCoin", JSON.stringify(updated));
    //     }}
    //   />
    // </div>

    <Container>
      {" "}
      <br />
      <Button className="mt-2" variant="secondary" onClick={() => navigate(-1)}>
        ← Back
      </Button>
      <h2 className="my-4">Reviews for {coin}</h2>
      <ListGroup>
        {paginated.map((r, i) => (
          <ListGroup.Item key={i}>
            <strong>Username: </strong>
            {r.username || "Anonymous"} <br />
            <strong>Rating:</strong> {r.rating || "N/A"} ★ <br />
            <strong>Comment:</strong> {r.value}
          </ListGroup.Item>
        ))}
      </ListGroup>
      <Pagination className="mt-3">
        {[...Array(totalPages).keys()].map((num) => (
          <Pagination.Item
            key={num}
            active={num + 1 === currentPage}
            onClick={() => setCurrentPage(num + 1)}
          >
            {num + 1}
          </Pagination.Item>
        ))}
      </Pagination>
    </Container>
  );
};

export default AdminCoinDetail;
